<template>
<div class="chapter">
<div class="inner_page">
<div id="a03_ded">
<p class="ded">To</p>
<p class="ded1">the memory of two distinguished Admirals,<br/>upholders of a proud tradition—<br/>Lords Jellicoe and Beatty</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_ded.vue?2a2e2d0a